export const translations = {
  configuracoes: {
    pt: 'Configurações',
    en: 'Settings',
    de: 'Einstellungen',
    es: 'Configuración',
  },
  novaTaxa: {
    pt: 'Nova Taxa Vale Pedágio',
    en: 'New Toll Voucher Fee',
    de: 'Neue Mautgebühr',
    es: 'Nueva Tasa de Vale de Peaje',
  },
  porcentagem: {
    pt: 'Porcentagem da Taxa (%)',
    en: 'Toll Percentage (%)',
    de: 'Prozentsatz des Gebühr (%)',
    es: 'Porcentaje de la tasa (%)',
  },
  voltar: {
    pt: 'Voltar',
    en: 'Go back',
    de: 'Geh zurück',
    es: 'Regresa',
  },
  cancelar: {
    pt: 'Cancelar',
    en: 'Cancel',
    de: 'kündiger',
    es: 'Cancelar',
  },
  cadastrar: {
    pt: 'Cadastrar',
    en: 'Register',
    de: 'Katastern',
    es: 'Registrar',
  },
};